/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import ContentLoader from "react-content-loader";
import { useWindowSize } from "react-use";
import { theme } from "@nordcloud/gnui";

export function BrickLoader(
  props: React.ComponentPropsWithoutRef<typeof ContentLoader>
) {
  return (
    <ContentLoader
      speed={2}
      backgroundColor={theme.color.background.ui02}
      foregroundColor={theme.color.background.ui04}
      style={{ width: "100%", height: "100%" }}
      {...props}
    >
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
    </ContentLoader>
  );
}

export function ResponsiveBrickLoader({
  height,
  ...rest
}: React.ComponentPropsWithoutRef<typeof ContentLoader> & {
  height: number;
}) {
  const { width } = useWindowSize();

  return (
    <ContentLoader
      speed={2}
      backgroundColor={theme.color.background.ui02}
      foregroundColor={theme.color.background.ui04}
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: "block", width: "100%", height: "auto" }}
      {...rest}
    >
      <rect x="0" y="0" rx="3" ry="3" width="100%" height="100%" />
    </ContentLoader>
  );
}
